import { isFulfilled, isPending, isRejected } from "./reducerUtils";
let initialState = {
    surveyList: {},
    surveyListLoading: false,
};

const SMRSurveyReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending("FETCH_SURVEY_LIST"):
            return (state = {
                ...state,
                surveyListLoading: true,
                surveyList: {},
            });
        case isRejected("FETCH_SURVEY_LIST"):
            return (state = {
                ...state,
                surveyListLoading: false,
                surveyList: {},
            });
        case isFulfilled("FETCH_SURVEY_LIST"): {
            return (state = {
                ...state,
                surveyListLoading: false,
                surveyList: action.payload.data,
            });
        }

        case "UPDATE_SURVEY":
            return (state = {
                ...state,
                surveyListLoading: false,
                surveyList: action.payload || [],
            });

        default:
            return state;
    }
};
export default SMRSurveyReducer;
